export class InvestigationApprovalRequestEntity {
  public id!: string;
  public workflowStepId!: string | null;
  public workflowStepName!: string;
  public approverUserId!: string;
  public approverName!: string;
  public approverRole!: string;
  public decision!: string | null;
  public decidedAt!: string | null;
  public denialNotes!: string | null;
  public canActNow!: boolean;
  public isClosureApproval!: boolean;
}
